import React from "react";
import DarkLogo from "../../resources/images/logos/FullColourLogoBlackTransparent.png";
import LightLogo from "../../resources/images/logos/FullColourLogo.png";
import makeStyles from "@mui/styles/makeStyles";
import { Box, useTheme } from "@mui/system";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundImage: `url(${
      theme.palette.mode === "dark" ? DarkLogo : LightLogo
    })`,
    height: "100px",
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
    marginBottom: "25px",
  },
  tagline: {},
}));

const Logo = () => {
  const classes = useStyles();
  const theme = useTheme();

  return (
    <Box display={"flex"} justifyContent={"center"}>
      <a href="https://fairtree.com" target="_blank" rel="noopener noreferrer">
        <img
          src={theme.palette.mode === "dark" ? DarkLogo : LightLogo}
          alt="logo"
          height={70}
        />
      </a>
    </Box>
  );
};

export default Logo;
